import { EditCustomerContactModal } from './components/modals/EditCustomerContactModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const EditCustomerContactView = () => {
  const { t } = useTranslation();
  const [isOperatorModalOpen, setIsOperatorModalOpen] = useState(true);

  return (
    <>
      <EditCustomerContactModal
        key={`${isOperatorModalOpen.toString()}-create-operator`}
        open={isOperatorModalOpen}
        handleAbort={() => {
          setIsOperatorModalOpen(false);
          window.history.back();
        }}
        title={t('edit_contact_information')}
      />
    </>
  );
};
